// extracted by mini-css-extract-plugin
module.exports = {"VideoContainer":"ElementVideo_VideoContainer__3y4YK"};